import { PortfolioSummaryComponentState } from 'widgets/portfolioSummary/store/instances/component/PortfolioSummaryComponentState';
import {
    createUpdateWidgetComponentStateAction,
    WidgetSetComponentAction,
} from 'widgets/store/component/actions';
import { WidgetType } from 'widgets/WidgetType';

export type PortfolioSummaryComponentAction =
    WidgetSetComponentAction<PortfolioSummaryComponentState>;

export const createUpdatePortfolioSummaryComponentStateAction = (
    widgetKey: string,
    delta: Partial<PortfolioSummaryComponentState>
) =>
    createUpdateWidgetComponentStateAction<PortfolioSummaryComponentState>(
        WidgetType.PORTFOLIO_SUMMARY
    )(widgetKey, delta);
